// import * as React from "react";
// import { DataGrid } from "@mui/x-data-grid";
// import { Box } from "@mui/material";
// import { useTranslation } from "react-i18next";

// const CashiInOutTable = ({ additionalData, pagination }) => {
//   const { t, i18n } = useTranslation();
//   const [pageSize, setPageSize] = React.useState(50);

//   const rows = React.useMemo(
//     () =>
//       (additionalData || []).map((row, index) => ({
//         id: row.id || index,
//         ...row,
//       })),
//     [additionalData]
//   );

//   const columns = [
//     { field: "session_name", headerName: t("Session"), flex: 1 },
//     { field: "cashier_name", headerName: t("Cashier Name"), flex: 1.5 },
//     { field: "cash_type", headerName: t("Action"), flex: 1 },
//     { field: "date", headerName: t("Date & Time"), flex: 1.2 },
//     { field: "amount", headerName: t("Amount"), flex: 1 },
//     { field: "payment_ref", headerName: t("Reason"), flex: 1.5 },
//   ];

//   const arabicLocale = {
//     columnMenuUnsort: t("Unsort"),
//     columnMenuSortAsc: t("Sort Ascending"),
//     columnMenuSortDesc: t("Sort Descending"),
//     columnMenuHideColumn: t("Hide Column"),
//     columnMenuFilter: t("Filter"),
//     footerRowSelected: (count) => t("{{count}} row(s) selected", { count }),
//     // Add more keys as needed
//   };

//   return (
//     <Box sx={{ width: "100%", mt: 2 }}>
//       <div style={{ height: 620, width: "100%" }}>
//         <DataGrid
//           rows={rows}
//           columns={columns}
//           pageSize={pageSize}
//           onPageSizeChange={(newSize) => {
//             setPageSize(newSize);
//             pagination({ limit: newSize, offset: 0 });
//           }}
//           rowsPerPageOptions={[10, 20, 50, 100]}
//           pagination
//           paginationMode="server"
//           disableColumnMenu={false}  //hides the entire menu (Filter, Hide column, etc.)
//           disableColumnFilter={true} // hides only the filter
//           disableColumnSelector={false} // hides “Hide columns”
//           disableColumnSort={false} // disables sorting from the menu
//           localeText={i18n.language === "ar" ? arabicLocale : {}}
//           sx={{
//             "& .MuiDataGrid-columnHeaders": {
//               backgroundColor: "black", // blue header
//               color: "black",
//               fontWeight: "bold",
//             },
//           }}
//         />
//       </div>
//     </Box>
//   );
// };

// export default CashiInOutTable;



import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";
import { useSelector } from "react-redux";

const CashiInOutTable = ({ additionalData, pagination }) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  )

  const openOrderList = (id) => {
    navigate(`/vendorDetails?id=${id}`);
  };

  const data = useMemo(
    () =>
      //   additionalData?.status
      //     ? additionalData?.all_product
      additionalData || [],
    [additionalData]
  );

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);
  // console.log("data==>", data);

  const columns = useMemo(
    () => [
      {
        Header: (
          <div className="text-start justify-start" title={t("Session")}>
            {t("Session")}
          </div>
        ),
        accessor: "session_name",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start">{row.original.session_name}</div>
        ),
      },
      {
        Header: (
          <div className="text-start justify-start" title={t("Cashier Name")}>
            {t("Cashier Name")}
          </div>
        ),
        accessor: "cashier_name",
        headerClassName: "text-start",
        Cell: ({ row }) => {
          const cashierName = row.original.cashier_name;
          const cashierPhone = row.original.cashier_phone;
          const cashierEmail = row.original.cashier_email;

          return (
            <div className="text-start justify-start">
              {cashierPhone ? (
                // If cashier phone exists, display the name with phone number
                `${cashierName} (${cashierPhone})`
              ) : (
                // Otherwise, display the name with email
                `${cashierName} (${cashierEmail})`
              )}
            </div>
          );
        },
      },
      {
        Header: (
          <div className="text-start" title={t("Phone Number")}>
            {t("Action")}
          </div>
        ),
        accessor: "cash_type",
        Cell: ({ row }) => (
          <div className="text-start">{t(row.original.cash_type)}</div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Date & Time")}>
            {t("Date & Time")}
          </div>
        ),
        accessor: "date",
        Cell: ({ row }) => (
          <div className="text-start">{row.original.date}</div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Credit Amount")}>
            {t("Amount")}
          </div>
        ),
        accessor: "amount",
        Cell: ({ row }) => (
          <div className="text-start">{`EGP ${row.original.amount}`}</div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Reason")}>
            {t("Reason")}
          </div>
        ),
        accessor: "payment_ref",
        Cell: ({ row }) => (
          <div className="text-start">
            {row.original.payment_ref ? (row.original.payment_ref) : "--"}
          </div>
        ),
      },

      ...(allStores
        ? [
          {
            Header: (
              <div className="text-start" title={t("Store Name")}>
                {t("Store Name")}
              </div>
            ),
            accessor: "store_name",
            Cell: ({ row }) => (
              <div className="text-start">
                {row.original.store_name ? (row.original.store_name) : "--"}
              </div>
            ),
          }
        ]
        : []),
    ],
    [t]
  );


  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 50 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);

  return (
    <>
      <div
        className="container flex flex-col mx-auto mt-4"
        style={{ maxWidth: "100%" }}
      >
        {additionalData?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            {/* Header Table (Fixed) */}
            <div>
              <table
                className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <thead>
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps()
                            );
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className="py-3 whitespace-nowrap"
                              style={{ width: column.width }} // Set column width
                            >
                               <div className="flex flex-row items-center ms-2 text-sm leading-tight ">
                                                                                      {column.render("Header")}
                                                                                      {column.canSort && (
                                                                                        <span className="ms-1">
                                                                                          {column.isSorted ? (
                                                                                            column.isSortedDesc ? (
                                                                                              <img
                                                                                                src={Vectorsorting}
                                                                                                style={{
                                                                                                  minHeight: 10,
                                                                                                  minWidth: 10,
                                                                                                }}
                                                                                                alt="vector"
                                                                                              />
                                                                                            ) : (
                                                                                              <img
                                                                                                className="rotate-180"
                                                                                                src={Vectorsorting}
                                                                                                alt="vector"
                                                                                              />
                                                                                            )
                                                                                          ) : (
                                                                                            // 👇 Show a neutral icon when column is not sorted
                                                                                            <img
                                                                                              src={Vectorsorting}
                                                                                              alt="sortable"
                                                                                              style={{
                                                                                                minHeight: 10,
                                                                                                minWidth: 10,
                                                                                                opacity: 0.3,
                                                                                              }}
                                                                                            />
                                                                                          )}
                                                                                        </span>
                                                                                      )}
                                                                                    </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
              </table>
            </div>

            {/* Body Table (Scrollable) */}
            <div
              className="scrollbar-none bg-white"
              style={{
                overflowY: "auto",
                maxHeight: "620px", // Adjust height as needed
              }}
            >
              <table
                className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <React.Fragment key={row.id}>
                        <tr
                          {...row.getRowProps()}
                          className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                        //   onClick={() => openOrderList(row.original.id)}
                        >
                          {row.cells.map((cell, index) => (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              className={`p-2 text-[#272728] h-1212 text-sm font-normal ${index < row.cells.length - 1 ? "relative" : ""
                                } ${cell?.column?.Header == "Product"
                                  ? "cursor-pointer"
                                  : ""
                                }`}
                            //   style={{ width: cell.column.width }} // Match column width
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {page.length === 0 && (
                    <tr>
                      <td colSpan={"100%"}>
                        <Empty
                          className="mt-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div className="">
              <CustomPagination
                data={data?.length}
                pageIndex={pageIndex}
                pageCount={page?.length}
                canPreviousPage={pageIndex != 1 ? true : false}
                canNextPage={data?.length == pageSize ? true : false}
                gotoPage={(page) => {
                  nextPage(page);
                }}
                previousPage={() => {
                  setpageIndex(pageIndex - 1);
                }}
                nextPage={() => {
                  setpageIndex(pageIndex + 1);
                }}
                pageSize={pageSize}
                setPageSize={(pageSize) => {
                  setPageSize(pageSize);
                }}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CashiInOutTable;
